var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card flex-md-row" }, [
    _c(
      "div",
      {
        staticClass: "card-body d-flex flex-column align-items-start py-2 px-3",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-row align-items-center justify-content-start w-100",
          },
          [
            _c(
              "div",
              {
                staticClass: "d-flex flex-column justify-content-between mr-3",
              },
              [
                _c("span", { staticClass: "badge badge-primary mb-2" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.order) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _vm.service
                  ? _c(
                      "span",
                      { staticClass: "badge", class: _vm.classServiceCode },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.serviceCode) +
                            "\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "w-100" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-row align-items-center justify-content-between w-100 mb-1",
                },
                [
                  _c(
                    "strong",
                    { staticClass: "d-inline-block text-info text-break" },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.title) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.readonlyForm
                    ? _c("i", {
                        staticClass: "cursor-pointer fa fa-times close",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.removeResource.apply(null, arguments)
                          },
                        },
                      })
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.name
                ? _c("p", { staticClass: "small mb-0 text-break" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.name) +
                        "\n                "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.filteredCustomParameters.length
                ? _c(
                    "form",
                    { staticClass: "custom-parameters" },
                    [
                      _c("p", { staticClass: "mb-0 mt-3 small" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                `global.resources.items.resource.custom_parameters`
                              )
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("hr", { staticClass: "mt-0 mb-2" }),
                      _vm._v(" "),
                      _vm._l(_vm.filteredCustomParameters, function (param) {
                        return _c(
                          "div",
                          {
                            key: `parameter-${param.key}`,
                            staticClass: "form-group row mb-0 small",
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "col-sm-auto col-form-label",
                                attrs: {
                                  for: `${_vm.itemId}-parameter-${param.key}`,
                                },
                              },
                              [_vm._v(_vm._s(param.label))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-sm d-flex align-items-center",
                              },
                              [
                                param.type == "checkbox"
                                  ? [
                                      _c("input", {
                                        staticClass:
                                          "form-check-input position-static",
                                        attrs: {
                                          id: `${_vm.itemId}-parameter-${param.key}`,
                                          type: "checkbox",
                                          "false-value": false,
                                          "true-value": true,
                                        },
                                        domProps: { checked: param.value },
                                        on: {
                                          change: (evt) =>
                                            _vm.onChange(
                                              evt.target.checked,
                                              param
                                            ),
                                        },
                                      }),
                                    ]
                                  : [
                                      _c("input", {
                                        staticClass:
                                          "form-control form-control-sm",
                                        attrs: { type: "text" },
                                        domProps: { value: param.value },
                                        on: {
                                          input: (evt) =>
                                            _vm.onChange(
                                              evt.target.value,
                                              param
                                            ),
                                        },
                                      }),
                                    ],
                              ],
                              2
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }